import { render, staticRenderFns } from "./LegalMentions.vue?vue&type=template&id=3f96ee89&scoped=true&"
import script from "./LegalMentions.vue?vue&type=script&lang=js&"
export * from "./LegalMentions.vue?vue&type=script&lang=js&"
import style0 from "./LegalMentions.vue?vue&type=style&index=0&id=3f96ee89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96ee89",
  null
  
)

export default component.exports